import {
  AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel,
} from "react-accessible-accordion";
import styled from "styled-components";
import variables from "../../styles/variables";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 40px auto;
`;

export const Container = styled.div`
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;

  @media screen and (max-width: 1023px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const FaqSectionTitle = styled.h2`
  color: ${variables.colorBlack};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  margin-bottom: 24px;

  @media screen and (max-width: 767px) {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }
`;

export const FaqItem = styled(AccordionItem)`
  background: ${variables.colorWhite};
  border-radius: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 24px;
  margin-bottom: 24px;

  @media screen and (max-width: 767px) {
    padding: 0 12px;
  }

  &:last-child {
    margin-bottom:0;
  }
`;

export const FaqHeading = styled(AccordionItemHeading)`
  width: 100%;
  height: 100%;
`;

export const FaqButton = styled(AccordionItemButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 19px 0;
  cursor: pointer;
  /* When content is not expanded */
  &[aria-expanded='false'] .buttonWrapper::after {
    content: '+';

    @media screen and (max-width: 767px) {
      font-size: 24px;
    }
  }
  /* When content is expanded */
  &[aria-expanded='true'] .buttonWrapper::after {
    content: '-';
    transform: scaleX(2);
    margin-bottom: 3px;

    @media screen and (max-width: 767px) {
      font-size: 24px;
    }
  }

  @media screen and (max-width: 767px) {
    padding: 11px 0;
  }
`;

export const FaqItemTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 0;
`;

export const FaqDetails = styled(AccordionItemPanel)`
  width: 100%;
  flex-basis: 100%;
  padding: 0 44px 24px 0;
  line-height: 30px;
  @media screen and (max-width: 767px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ExpandButtonWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${variables.colorBlack};
  font-size: 30px;
  font-weight: 100;
`;
